(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _MobileMenu = _interopRequireDefault(require("./modules/MobileMenu"));
var _MobileDropdown = _interopRequireDefault(require("./modules/MobileDropdown"));
var _HeaderSearch = _interopRequireDefault(require("./modules/HeaderSearch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Import JS classes
//import example from "./modules/example.js";

// Initiate JS classes
//var xmple = new example();
var mobileMenu = new _MobileMenu["default"]();
var mobileDropdown = new _MobileDropdown["default"]();
var headerSearch = new _HeaderSearch["default"]();

},{"./modules/HeaderSearch":2,"./modules/MobileDropdown":3,"./modules/MobileMenu":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ── Herbruikbare zoekbox (desktop én mobiel panel) ──────
var SearchBox = /*#__PURE__*/function () {
  function SearchBox(input, results, ajaxUrl) {
    _classCallCheck(this, SearchBox);
    this.input = input;
    this.results = results;
    this.ajaxUrl = ajaxUrl;
    this.timeout = null;
    this.controller = null;
    this.focusIndex = -1;
    this.events();
  }
  return _createClass(SearchBox, [{
    key: "events",
    value: function events() {
      var _this = this;
      this.input.addEventListener('input', function () {
        return _this.onInput();
      });
      this.input.addEventListener('keydown', function (e) {
        return _this.onKeydown(e);
      });
      this.input.addEventListener('focus', function () {
        if (_this.input.value.trim().length >= 1) _this.onInput();
      });
      document.addEventListener('click', function (e) {
        return _this.onClickOutside(e);
      });
    }
  }, {
    key: "onInput",
    value: function onInput() {
      var _this2 = this;
      clearTimeout(this.timeout);
      var query = this.input.value.trim();
      if (query.length < 1) {
        this.clearResults();
        return;
      }
      this.showLoading();
      this.timeout = setTimeout(function () {
        return _this2.search(query);
      }, 200);
    }
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
        var url, res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.controller) this.controller.abort();
              this.controller = new AbortController();
              _context.prev = 2;
              url = "".concat(this.ajaxUrl, "?action=shop4_search&q=").concat(encodeURIComponent(query));
              _context.next = 6;
              return fetch(url, {
                signal: this.controller.signal
              });
            case 6:
              res = _context.sent;
              if (res.ok) {
                _context.next = 9;
                break;
              }
              throw new Error();
            case 9:
              _context.next = 11;
              return res.json();
            case 11:
              data = _context.sent;
              this.focusIndex = -1;
              this.renderResults(data);
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              if (_context.t0.name !== 'AbortError') this.clearResults();
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 16]]);
      }));
      function search(_x) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
  }, {
    key: "showLoading",
    value: function showLoading() {
      this.results.innerHTML = '<div class="hs-loading"><i class="fa-solid fa-spinner fa-spin"></i> Zoeken…</div>';
      this.results.classList.add('hs-results--open');
    }
  }, {
    key: "renderResults",
    value: function renderResults(items) {
      var _this3 = this;
      if (!items || !items.length) {
        this.results.innerHTML = '<div class="hs-empty"><i class="fa-solid fa-circle-xmark"></i> Geen resultaten gevonden.</div>';
        this.results.classList.add('hs-results--open');
        return;
      }
      var typeMap = {
        product: {
          label: 'Product',
          icon: 'fa-box'
        },
        page: {
          label: 'Pagina',
          icon: 'fa-file'
        },
        post: {
          label: 'Artikel',
          icon: 'fa-newspaper'
        }
      };
      var html = items.map(function (item) {
        if (item.subtype === 'product') return _this3.productHtml(item);
        var meta = typeMap[item.subtype] || {
          label: item.subtype,
          icon: 'fa-file'
        };
        return "<a class=\"hs-item\" href=\"".concat(item.url, "\" tabindex=\"-1\">\n        <i class=\"fa-solid ").concat(meta.icon, "\"></i>\n        <span class=\"hs-item__title\">").concat(item.title, "</span>\n        <span class=\"hs-item__type\">").concat(meta.label, "</span>\n      </a>");
      }).join('');
      this.results.innerHTML = html;
      this.results.classList.add('hs-results--open');
    }
  }, {
    key: "productHtml",
    value: function productHtml(item) {
      var thumb = item.thumb ? "<img class=\"hs-item__thumb\" src=\"".concat(item.thumb, "\" alt=\"\" loading=\"lazy\">") : "<span class=\"hs-item__thumb hs-item__thumb--empty\"><i class=\"fa-solid fa-box\"></i></span>";
      var sku = item.sku ? "<span class=\"hs-item__sku\">Art. ".concat(item.sku, "</span>") : '';
      var price = item.price ? "<span class=\"hs-item__price\">".concat(item.price, "</span>") : '';
      var stock = item.in_stock ? "<span class=\"hs-item__stock hs-item__stock--in\">Op voorraad</span>" : "<span class=\"hs-item__stock hs-item__stock--out\">Niet op voorraad</span>";
      return "<a class=\"hs-item hs-item--product\" href=\"".concat(item.url, "\" tabindex=\"-1\">\n      ").concat(thumb, "\n      <span class=\"hs-item__info\">\n        <span class=\"hs-item__title\">").concat(item.title, "</span>\n        <span class=\"hs-item__meta\">").concat(sku).concat(price).concat(stock, "</span>\n      </span>\n      <span class=\"hs-item__type\">Product</span>\n    </a>");
    }
  }, {
    key: "clearResults",
    value: function clearResults() {
      if (this.controller) this.controller.abort();
      this.results.innerHTML = '';
      this.results.classList.remove('hs-results--open');
      this.focusIndex = -1;
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(e) {
      if (e.key === 'Escape') {
        this.clearResults();
        return;
      }
      var items = this.results.querySelectorAll('.hs-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.focusIndex = Math.min(this.focusIndex + 1, items.length - 1);
        items[this.focusIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.focusIndex = Math.max(this.focusIndex - 1, -1);
        if (this.focusIndex >= 0) items[this.focusIndex].focus();else this.input.focus();
      }
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      var wrapper = this.input.closest('.header-search, .header-search-panel');
      if (wrapper && !e.target.closest('.header-search, .header-search-panel')) {
        this.clearResults();
      }
    }
  }]);
}(); // ── Hoofd-klasse: beheert desktop + mobiel panel ────────
var HeaderSearch = /*#__PURE__*/function () {
  function HeaderSearch() {
    _classCallCheck(this, HeaderSearch);
    var ajaxUrl = typeof params !== 'undefined' && params.ajaxurl ? params.ajaxurl : '/wp-admin/admin-ajax.php';

    // Desktop zoekbalk
    var deskInput = document.querySelector('.header-search__input');
    var deskResults = document.querySelector('.header-search__results');
    if (deskInput && deskResults) {
      deskResults.classList.add('hs-results');
      new SearchBox(deskInput, deskResults, ajaxUrl);
    }

    // Mobiel zoekpaneel
    var panelInput = document.querySelector('.header-search-panel__input');
    var panelResults = document.querySelector('.header-search-panel__results');
    if (panelInput && panelResults) {
      panelResults.classList.add('hs-results');
      this.mobileBox = new SearchBox(panelInput, panelResults, ajaxUrl);
    }
    this.setupMobilePanel();
  }
  return _createClass(HeaderSearch, [{
    key: "setupMobilePanel",
    value: function setupMobilePanel() {
      var _this4 = this;
      this.panel = document.querySelector('#search-panel');
      this.openBtn = document.querySelector('#open-search');
      this.closeBtn = document.querySelector('#close-search');
      this.input = document.querySelector('.header-search-panel__input');
      if (!this.panel || !this.openBtn) return;
      this.openBtn.addEventListener('click', function () {
        return _this4.openPanel();
      });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function () {
          return _this4.closePanel();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _this4.panel.classList.contains('header-search-panel--open')) {
          _this4.closePanel();
        }
      });
    }
  }, {
    key: "openPanel",
    value: function openPanel() {
      var _this5 = this;
      this.panel.classList.add('header-search-panel--open');
      if (this.input) setTimeout(function () {
        return _this5.input.focus();
      }, 60);
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      this.panel.classList.remove('header-search-panel--open');
      if (this.mobileBox) this.mobileBox.clearResults();
      if (this.input) this.input.value = '';
    }
  }]);
}();
var _default = exports["default"] = HeaderSearch;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MobileDropdown = /*#__PURE__*/function () {
  function MobileDropdown() {
    _classCallCheck(this, MobileDropdown);
    this.isMobile = function () {
      return window.innerWidth <= 980;
    };
    this.events();
  }
  return _createClass(MobileDropdown, [{
    key: "events",
    value: function events() {
      var _this = this;
      document.querySelectorAll("nav.main-navigation .menu-item-has-children > a").forEach(function (link) {
        link.addEventListener("click", function (e) {
          if (!_this.isMobile()) return;
          var subMenu = link.nextElementSibling;
          if (subMenu && subMenu.classList.contains("sub-menu")) {
            e.preventDefault();
            subMenu.classList.toggle("sub-menu--open");
          }
        });
      });
    }
  }]);
}();
var _default = exports["default"] = MobileDropdown;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MobileMenu = /*#__PURE__*/function () {
  function MobileMenu() {
    _classCallCheck(this, MobileMenu);
    this.menu = document.querySelector("nav.main-navigation");
    this.openButton = document.querySelector("#open-menu");
    this.closeButton = document.querySelector("#close-menu");
    if (this.menu && this.openButton && this.closeButton) {
      this.events();
    }
  }
  return _createClass(MobileMenu, [{
    key: "events",
    value: function events() {
      var _this = this;
      this.openButton.addEventListener("click", function () {
        return _this.openMenu();
      });
      this.closeButton.addEventListener("click", function () {
        return _this.closeMenu();
      });
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      this.menu.classList.add("main-navigation--open");
      this.openButton.style.display = "none";
      this.closeButton.classList.add("mobiel-close--active");
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.menu.classList.remove("main-navigation--open");
      this.openButton.style.display = "";
      this.closeButton.classList.remove("mobiel-close--active");
    }
  }]);
}();
var _default = exports["default"] = MobileMenu;

},{}]},{},[1]);
